import axiosInstance from "@/api/axios-instance";

export async function createCouplesDocument(bundleUsageId: string) {
  const response = await axiosInstance.post(`/document/create/couples/${bundleUsageId}`);
  
  if (!response.data.success) {
    throw new Error(response.data.error || "Failed to create couples therapy document");
  }
  
  return response.data;
}

